import { useDepositMatchPromoActivation } from '@/feature/promohub/hooks/use-deposit-match';
import { usePromotionsStore } from '@/feature/promohub/hooks/use-promotions-store';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { logger } from '@/utils/logging';

/**
 * Custom hook to handle deposit match promo activation logic.
 * This provides shared functionality for both regular deposit and 3DS deposit flows.
 */
export const useDepositMatchPromo = () => {
    const depositMatchPromo = usePromotionsStore(state => state.depositMatchPromo);
    const BONUS_ENGINE_V2_ENABLED = useJurisdictionStore(
        state => state.jurisdictionSettings?.globalSettings?.featureFlags?.bonus_engine_v2_enabled?.enabled
    );
    const clearDepositMatchPromo = usePromotionsStore(state => state.actions.clearDepositMatchPromo);
    const depositMatchPromoActivation = useDepositMatchPromoActivation();

    /**
     * Activates deposit match promo if conditions are met.
     * Should be called before making deposit/purchase requests.
     */
    const activatePromoIfExists = async (logTag: string) => {
        if (BONUS_ENGINE_V2_ENABLED && depositMatchPromo) {
            try {
                await depositMatchPromoActivation.mutateAsync(depositMatchPromo);
            } catch (e) {
                logger.warn(logTag, { message: `Failed to activate promo: ${depositMatchPromo}`, error: e });
            }
        }
    };

    /**
     * Clears deposit match promo from store.
     * Should be called in mutation onSettled callback.
     */
    const clearPromo = () => {
        clearDepositMatchPromo();
    };

    return {
        activatePromoIfExists,
        clearPromo,
    };
};
